import Article from './Article';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { withModel } from 'src/client/js/view/data-providers/model';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withModel,
  mapProps(props => ({
    ...props,
    link: localiseUrl(props.model.countryModel, props.link),
    categoryLink: props.categoryLink
      ? localiseUrl(props.model.countryModel, props.categoryLink)
      : null,
  })),
);

export default enhance(Article);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BlogArticles/Article/index.js